import React from "react";
import Image from "@/components/atoms/image";
import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";

const FooterBrandImage = ({ leftLogo }: any) => {
    const t = useTranslations('FooterBrandImage');
  
  return (
    <div className="container mx-auto px-4 py-48">
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          {/* {leftLogo.href ? ( */}
            <Link
              href={"https://ebupi.justica.gov.pt" as any}
              passHref
              target="_blank"
              aria-label={leftLogo.alt}
              title={t("logoBUPi")}
              className="flex items-center rounded-md"
            >
              <div className="flex flex-col md:flex-row md:items-center">
                <div className="relative">
                  <Image
                    src={leftLogo.url}
                    alt={leftLogo.alt}
                    width={248}
                    height={123}
                    className="w-[132px] h-[65px] md:w-[248px] md:h-[123px]"
                    loading="lazy"
                  />
                </div>
              </div>
            </Link>
          
        </div>

        <div>
          <Link
            href={"https://www.portugal.gov.pt" as any}
            passHref
            target="_blank"
            aria-label={t("gotoGovernament")}
            className="rounded-md"
          >
            <div className="relative">
              <Image
                src={"/img/portugal.svg"}
                alt={"República Portuguesa"}
                title={t("gotoGovernament")}
                width={150}
                height={150}
                style={{ objectFit: "cover", objectPosition: "left" }}
                loading="lazy"
              />
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FooterBrandImage;
